<template>
  <div>
    <NuxtLayout name="account">
      <NuxtLoadingIndicator />
      <LazyModulesPartnerPlaylistOrganismsListWrapper />
    </NuxtLayout>
  </div>
</template>
